import type { ReactNode } from 'react';
import { createPortal } from 'react-dom';

/**
 * Renders bottom sheets at <body>, out of the page's scroll container.
 *
 * A `.sheet-backdrop` is `position: fixed; z-index: 40` and the tab bar is
 * `position: relative; z-index: 20`, so on paper the sheet always wins. It does
 * in Chromium and in headless WebKit. It does NOT in Mobile Safari: the tab
 * pages are scroll containers (`.tab-page` is `position: relative` with
 * `overflow: hidden auto`), and iOS Safari scopes a fixed descendant of a
 * scroller to that scroller instead of to the viewport — so the sheet's z-index
 * stops competing with the tab bar's and the bar paints over it.
 *
 * On an iPhone 17 that hid the third row of the language picker (Español)
 * completely behind the tab bar, with no way to reach it.
 *
 * Portalling to <body> takes the sheet out of the scroller entirely, which is
 * where a modal belongs anyway. WalletPage and SorteiosPage already do this by
 * hand; this is the same move, named.
 */
export function SheetPortal({ children }: { children: ReactNode }) {
  if (typeof document === 'undefined') return <>{children}</>;
  return createPortal(<>{children}</>, document.body);
}
